<template>
    <div class="container">
       <vip-card
       @jump-classlist="jumpClassList" ref="vipcard" :vipCardId="vipCardId"></vip-card>
    </div>
</template>
<script>
import { VipCard } from 'lingdongliang-module'

export default {
  components: {
    'vip-card': VipCard
  },
  data () {
    return {
      vipCardId: 0
    }
  },
  methods: {
    jumpClassList (cobj, vobj, postion) {
      const classType = 'live'
      this.$router.push({ name: 'MyCourseInfo', params: { classId: cobj.class_id, classType: classType, vipCardId: vobj.vip_card_id } })
      this.zhuGeEventTrack(this.zhugeEvents.MyCourseCardClick, [
        vobj.goods_type === 5 ? '面授课' : '直播课',
        cobj.class_id + '',
        cobj.subject ? cobj.subject + '' : '',
        cobj.classState === '已完结' ? '已结束' : cobj.classState,
        postion
      ])
    }
  },
  created () {
    this.vipCardId = Number(this.$route.params.vipCardId) || 0
  }
}
</script>
<style lang="scss" scoped>
  .container{
    padding-top: 20px;
  }
@media (min-width: 300px) and (max-width: 767px) {
  .container{
    padding: 0px;
    margin-top: 0px!important;
  }
}
</style>
